import { Component, OnInit } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-t-exercises',
  templateUrl: './t-exercises.component.html',
  styleUrls: ['../../General/tiles.css','./t-exercises.component.css']
})
export class TExercisesComponent extends GeneralComponent implements OnInit {

  constructor(protected topicService: TopicService, protected _location: Location) {
    super(topicService);
   }

  ngOnInit() {
  }

}
